/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number Base Converter`)
};

const es_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Bases Numéricas`)
};

const de_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlenbasis-Umrechner`)
};

const nl_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getalbasiscalculator`)
};

const fr_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de base numérique`)
};

const it_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number Base Converter`)
};

const pt_br2_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Bases Numéricas`)
};

const pt_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Base de Números`)
};

const ja_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値ベース変換ツール`)
};

const zh_nb_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进制转换器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_nav_main", locale)
	if (locale === "en") return en_nb_nav_main(inputs)
	if (locale === "es") return es_nb_nav_main(inputs)
	if (locale === "de") return de_nb_nav_main(inputs)
	if (locale === "nl") return nl_nb_nav_main(inputs)
	if (locale === "fr") return fr_nb_nav_main(inputs)
	if (locale === "it") return it_nb_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_nb_nav_main(inputs)
	if (locale === "pt") return pt_nb_nav_main(inputs)
	if (locale === "ja") return ja_nb_nav_main(inputs)
	return zh_nb_nav_main(inputs)
};